import type { TableState, RowGroup, TableAction } from "./types";
import { createElement, type Dispatch } from "react";
import { encodeCellIdentifier } from "./utils";
import { TableCell } from "./TableCell";
import { TableRow } from "./TableRow";

type Props = {
  group: RowGroup;
  tableId: string;
  tableState: TableState;
  dispatch: Dispatch<TableAction>;
};

export function TableGroup({ group, tableId, tableState, dispatch }: Props) {
  const rowsInGroup = tableState.rows.filter((row) => row.group === group);

  if (rowsInGroup.length === 0) {
    return <></>;
  }

  return createElement(group, {
    children: rowsInGroup.map((_, elementIndex) => {
      const row = rowsInGroup[elementIndex];
      const cellsInRow = tableState.cells
        .filter((cell) => cell.originRow === row.index)
        .sort((a, b) => a.originCol - b.originCol);

      return (
        <TableRow key={row.index} row={row}>
          {cellsInRow.map((cell) => (
            <TableCell
              key={encodeCellIdentifier(cell)}
              tableId={tableId}
              cell={cell}
              dispatch={dispatch}
            />
          ))}
        </TableRow>
      );
    }),
  });
}
